import { EventModel } from '../../../network/rest/models/EventModel';
import { translations } from '../../../utils/staticContent';
import './style.scss';

interface Props {
    data: EventModel;
}

function Event({ data }: Props) {
    const { title, date, link, description } = data;
    return (
        <div className="Event">
            <table cellSpacing="0">
                <colgroup>
                    <col span={1} className="labels" />
                    <col span={2} className="values" />
                </colgroup>
                <tbody>
                    <tr className="first-row">
                        <td>{translations.when}</td>
                        <td>{date?.toLocaleTimeString('sl', { timeStyle: 'short' })}h</td>
                    </tr>
                    <tr className="second-row">
                        <td>{translations.where}</td>
                        <td>{description}</td>
                    </tr>
                    <tr className="third-row">
                        <td>{translations.what}</td>
                        <td>{title}</td>
                    </tr>
                    <tr className="fourth-row">
                        <td>{translations.url}</td>
                        <td>
                            <a href={link} target="_blank" rel="noreferrer">
                                {link}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Event;
